import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import Footer from './Footer';
import ImpersonationBanner from '../common/ImpersonationBanner';

export default function AppLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const toggleSidebar = () => {
    if (window.innerWidth <= 900) setSidebarOpen((v) => !v);
    else setSidebarCollapsed((v) => !v);
  };

  return (
    <div className={`app-layout ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
      <Sidebar open={sidebarOpen} collapsed={sidebarCollapsed} onClose={() => setSidebarOpen(false)} />
      <div className="main-area">
        <ImpersonationBanner />
        <Header onToggleSidebar={toggleSidebar} />
        <main>
          <Outlet />
        </main>
        <Footer />
      </div>
    </div>
  );
}